import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { AppCoreService } from "src/app/services/app-core.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { NetworkService } from "src/app/services/network.service";
import { GeoService } from "src/app/services/geo.service";
import { CompanyService } from "src/app/services/company.service";
import { AddressBookService } from "src/app/services/general/addressbook.service";
import { RateValidation } from "src/app/models/validator";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { SupplementaryInvoiceService } from "src/app/services/misc/supplementary/supplementary.service";
import { Utilities } from "src/app/models/utilities";
import { forkJoin } from "rxjs";
@Component({
    selector: 'app-supplementary-invoice-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.scss']
})
export class SupplementaryInvoiceViewComponent implements OnInit, AfterViewInit {
    invoiceForm: FormGroup;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };
    isFormSubmitted = false;
    Id: number;
    context: any;
    ServiceCenterOptions: [];
    companyList: any[];
    documentOptions: any[] = [{ name: 'GSTIN (Normal)' }, { name: 'PAN Number' }, { name: 'Aadhaar Number' }, { name: 'Passport Number' }, { name: 'TAN Number' }, { name: 'VAT Number' }, { name: 'EORI' }, { name: 'FDA' }, { name: 'Others' }];
    billToResponse: any;
    formattedChargeList = [];
    locationInfo: any
    showServiceCenter: any;
    gridParams: any;

    private gridApi!: GridApi;
    private gridApi2!: GridApi;
    private gridColumnApi!: ColumnApi;
    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: false,
        domLayout: "autoHeight"
    };
    gridOptions: GridOptions = {
        rowSelection: 'multiple',
        pagination: true,
        paginationPageSize: 10,
        suppressRowClickSelection: false,
        domLayout: "autoHeight"
    }
    rowData: any[] = [];
    columnDefs = [
        { headerName: 'Description', field: 'description', minWidth: 240 },
        { headerName: 'Amount', field: 'itemamount', cellStyle: { textAlign: 'end' } },
        // {
        //     headerName: 'Fuel', field: 'isitemfuel',
        //     cellRenderer: (params: { value: boolean; }) => {
        //         let statusHtml = '<span class="badge  bg-warning">No</span>';
        //         if (params.value) {
        //             statusHtml = '<span class="badge bg-success">Yes</span>';
        //         }
        //         return statusHtml;
        //     },
        //     cellStyle: { textAlign: 'center' }
        // },
        // { headerName: 'Fuel Amt', field: 'fuelamount', cellStyle: { textAlign: 'end' } },
        // {
        //     headerName: 'Fuel Tax', field: 'fueltax',
        //     cellRenderer: (params: { value: boolean; }) => {
        //         let statusHtml = '<span class="badge  bg-warning">No</span>';
        //         if (params.value) {
        //             statusHtml = '<span class="badge bg-success">Yes</span>';
        //         }
        //         return statusHtml;
        //     },
        //     cellStyle: { textAlign: 'center' }
        // },
        // { headerName: 'Fuel Tax Amt', field: 'fueltaxamount', cellStyle: { textAlign: 'end' } },
        {
            headerName: 'Tax', field: 'tax',
            cellRenderer: (params: { value: boolean; }) => {
                let statusHtml = '<span class="badge  bg-warning">No</span>';
                if (params.value) {
                    statusHtml = '<span class="badge bg-success">Yes</span>';
                }
                return statusHtml;
            },
            cellStyle: { textAlign: 'center' }
        },
        {
            headerName: 'IGST', field: 'igst',
            minWidth: 90,
            cellRenderer: (params: { data: { tax: boolean; taxes:any; }; }) => {
                return params.data.tax ? params.data?.taxes?.tax?.igst : 0;
            }
        },
        {
            headerName: 'CGST', field: 'cgst',
            minWidth: 90,
            cellRenderer: (params: { data: { tax: boolean; taxes:any }; }) => {
                return params.data.tax ? params.data?.taxes?.tax?.cgst : 0;
            }
        },
        {
            headerName: 'SGST', field: 'sgst',
            minWidth: 90,
            cellRenderer: (params: { data: { tax: boolean; taxes:any; }; }) => {
                return params.data.tax ? params.data?.taxes?.tax?.sgst : 0;
            }
        },
        // { headerName: 'Tax Amt', field: 'fueltaxamount', cellStyle: { textAlign: 'end' } },
        { headerName: 'Total', field: 'itemtotal', cellStyle: { textAlign: 'end' } },
    ];
    useEnterKey: any;

    constructor(
        private formBuilder: FormBuilder,
        private appCoreService: AppCoreService,
        private serviceCenter: NetworkService,
        private ngxLoaderService: NgxUiLoaderService,
        private invoiceService: SupplementaryInvoiceService,
        private geoService: GeoService,
        private router: Router,
        private route: ActivatedRoute,
        private companyService: CompanyService,
        private addressbookService: AddressBookService,
        private chargesService: ChargesService,
        private utilities: Utilities,
    ) {
        this.context = { componentParent: this };
    }
    currentDate = this.formateDate(new Date()).dateString;

    ngOnInit(): void {
        this.Id = this.route.snapshot.params['id'];
        this.invoiceForm = this.formBuilder.group({
            ddlBillType: [null, Validators.required],
            ddlCompany: [null, Validators.required],
            ddlServiceCenter: [null],
            txtInvoiceDate: [this.currentDate],
            txtInvoiceNo: [null],
            txtBOEDate: [null],
            txtBOENo: [null],
            txtAwbNo: [null, Validators.required],
            switchSenderRecv: ['sender'],

            billingoInfoForm: this.formBuilder.group({
                ddlDocumentType: [null],
                ddlDocumentNo: [null],
                txtRemark: [null],
            }),
            infoForm: this.formBuilder.group({
                txtName: [null],
                txtConatctPerson:[null],
            }),

            chargesForm: this.formBuilder.group({
                txtDescription: [null],
                txtAmount: [null, RateValidation],
                // chkFuel: ['No'],
                // txtFuelAmt: [{ value: 0.00, disabled: true }],
                // chkFuelTax: ['No'],
                // txtFuelTaxAmount: [{ value: 0.00, disabled: true }],
                chkTax: ['No'],
                txtTaxAmount: [{ value: 0.00, disabled: true }],
                txtTotal: [{ value: 0.00, disabled: true }]
            }),

            locationForm: this.formBuilder.group({
                ddlCountry: [null],
                ddlState: [null],
                ddlCity: [null],
                txtPincode: [null],
                txtAddress1: [null],
                txtAddress2: [null],
                txtArea: [null],
                txtMobileNo: [null],
                txtTelephoneNo: [null],
            }),

        });
        this.checkPermission();
        if (this.permConfig.isViewAllowed) {
            this.invoiceForm.disable();
            this.loadDataFromAPI();
        }

    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.invoiceForm) : null;
    };

    loadDataFromAPI() {
        try {
            forkJoin({
                description: this.chargesService.GetAll(''),
                servicecenter: this.serviceCenter.GetAllServiceCenters(),
                companies: this.companyService.GetAll()
            }).subscribe({
                next: (val) => {
                    if (val.companies.success && val.companies.data) {
                        this.companyList = val.companies.data;
                        // Select default company
                        this.invoiceForm.get('ddlCompany').setValue(this.companyList.find(x => x.isdefault)?.id);
                        this.onChangeCompany();
                    }
                    if (val.servicecenter.success && val.servicecenter.data) {
                        this.ServiceCenterOptions = val.servicecenter.data;
                    }
                    if (val.description.success && val.description.data) {
                        this.formattedChargeList = val.description.data?.length
                            ? val.description.data.filter(item =>
                                item.chargetype.some(type => type.toLowerCase() === 'supplementary'))
                            : null;
                    }
                },
                error: (error) => {
                    this.appCoreService.showMessage(error,'','error');
                },
                complete: () => {
                    // console.log('API calls completed.');
                    this.bindById(this.Id);
                }
            });
        } catch (error) {
            console.error('Error in loadDataFromAPI:', error);
        }
    }


    checkPermission(): any {
        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
        const permission = userData.config.filter(x => x.categoryname === 'Supplementary');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    bindById(id: number) {
        this.invoiceService.GetById(id).subscribe(res => {
            if (res && res.success) {
                const hd = res.data?.headerdetails[0];
                this.rowData = res.data?.chargesdetails;
                this.invoiceForm.patchValue({
                    ddlBillType: hd.billtype,
                    ddlCompany: hd.companyid,
                    ddlServiceCenter: hd.servicecenterid,
                    txtInvoiceDate: this.formateDate(hd.invoicedate).dateString,
                    txtInvoiceNo: hd.invoicenofull,
                    txtBOENo: hd.boeno,
                    txtBOEDate: this.formateDate(hd.boedate).dateString,
                    txtAwbNo: hd.awbnumber,
                    switchSenderRecv: hd.billto === 'Shipper' ? 'sender' : 'receiver',
                    billingoInfoForm: {
                        ddlDocumentType: hd.billinginfo ? hd.billinginfo.documenttype : null,
                        ddlDocumentNo: hd.billinginfo ? hd.billinginfo.documentno : null,
                        txtRemark: hd.billinginfo ? hd.billinginfo.remark : null
                    }
                });
                this.invoiceForm.get('infoForm').patchValue({
                    txtName: hd.billtodetails ? hd.billtodetails.name : null,
                    txtConatctPerson : hd.billtodetails ? hd.billtodetails.contactperson : null
                });

                this.locationInfo = hd.billtodetails;
                for (let item of this.rowData) {
                    const charge = this.formattedChargeList.find(charge => charge.id === item.chargesid);
                    if (charge) {
                        item.description = charge.name;
                    }
                }
            }
        })
    }


    onChangeCompany() {
        //if billto company then show service center
        if (this.companyList.filter(x => x.id == this.invoiceForm.get('ddlCompany').value)[0]?.billto == 'Service Center') {
            this.showServiceCenter = true;
            this.invoiceForm.get('ddlServiceCenter').setValidators([Validators.required]);
        } else {
            this.showServiceCenter = false;
            this.invoiceForm.get('ddlServiceCenter').clearValidators();
        }
        this.invoiceForm.get('ddlServiceCenter').updateValueAndValidity();
    }


    formateDate(date?: any) {
        const inputDate = date != null || undefined ? new Date(date) : new Date();
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
        const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
        const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
        const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
        const dateString = `${year}-${month}-${day}`;
        return { dateString, dateTimeString };
    }

    

    onGridReady(params: GridReadyEvent) {
        this.gridParams = params;
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }
}
